import React from 'react';
import BrandArrow from '../ui/BrandArrow';
import './PhotographerCard.css';

const PhotographerCard = () => {
  const photographers = [
    { handle: '@efectowoweventos', url: 'https://www.instagram.com/efecto.wow.eventos/' },
  ];

  return (
    <section className="sqg">
      {/* ── ¿QUÉ ES SOLE COSTILLA GROUP? ── */}
      <div className="sqg__top">
        <div className="sqg__top-inner">
          <h2 className="sqg__title">
            ¿Qué es Sole<br />Costilla Group?
          </h2>
          <div className="sqg__text">
            <div className="hero__btn-arrows">
    <BrandArrow />
  </div>
            <p className="sqg__text-content">
              Es mucho más que un equipo: es una familia de colaboradores profesionales
              que trabajan con la misma pasión, responsabilidad y entrega que yo. Lo creé
              pensando en vos, que querrás disfrutar tu evento sin preocuparte por todo lo
              demás. Por eso te acompaño con mis recomendados estrella, especialistas de
              confianza en cada área.
            </p>
          </div>
        </div>
      </div>

      {/* ── NUESTROS PROVEEDORES ── */}
      <div className="sqg__bottom">
        <h3 className="sqg__providers-title">Nuestros Provedores</h3>
        <div className="sqg__providers-bar">
          {photographers.map((photographer, index) => (
            <a
              key={index}
              href={photographer.url}
              target="_blank"
              rel="noopener noreferrer"
              className="sqg__provider-link"
            >
              {photographer.handle}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhotographerCard;